module.exports = __webpack_public_path__ + "img/more_plan_actions_approval_status_1.svg";